import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Wrapper } from "app/NativeComponents/common";
import { saveData } from "app/NativeActions";

const queryString = require("query-string");

class BranchAndGetParamsWrapper extends Component {
  getQueryParams(location) {
    if (location) {
      const parsed = queryString.parse(location.search);

      if (parsed._branch_match_id) {
        if (parsed._branch_match_id != "") {
          this.props.updateMarketingUser({
            prop: "branch_id",
            value: parsed._branch_match_id
          });
          window.localStorage.setItem("branch_id", parsed._branch_match_id);
        }
      }

      if (parsed.interest) {
        if (parsed.interest !== "") {
          let interest_array = parsed.interest.split(",");
          for (let i = 0; i < interest_array.length; i++) {
            if (interest_array[i] === "street") {
              interest_array[i] = "driving";
            }
          }

          let combined_interest_array = window.localStorage.getItem("interest");
          if (
            combined_interest_array &&
            combined_interest_array.split(",").length > 0
          ) {
            combined_interest_array = combined_interest_array.split(",");

            for (let i = 0; i < interest_array.length; i++) {
              let found_item = false;
              for (let j = 0; j < combined_interest_array.length; j++) {
                if (interest_array[i] === combined_interest_array[j]) {
                  found_item = true;
                }
              }
              if (!found_item) {
                combined_interest_array.push(interest_array[i]);
              }
            }
            this.props.updateMarketingUser({
              prop: "interest",
              value: combined_interest_array
            });
            combined_interest_array = combined_interest_array.join(",");
            combined_interest_array = combined_interest_array.replace(/^,/, "");
            window.localStorage.setItem("interest", combined_interest_array);
          } else {
            this.props.updateMarketingUser({
              prop: "interest",
              value: interest_array
            });
            window.localStorage.setItem("interest", interest_array.join(","));
          }
        }
      }

      if (parsed.promo) {
        if (parsed.promo != "") {
          this.props.updateMarketingUser({
            prop: "promoText",
            value: parsed.promo
          });
          window.localStorage.setItem("promo", parsed.promo);
          window.localStorage.setItem("promoText", parsed.promo);
        }
      }
      if (parsed.campaign) {
        if (parsed.campaign != "") {
          this.props.updateMarketingUser({
            prop: "from_campaign",
            value: parsed.campaign
          });
          window.localStorage.setItem("from_campaign", parsed.campaign);
        }
      }
      if (parsed.source) {
        if (parsed.source != "") {
          this.props.updateMarketingUser({
            prop: "from_source",
            value: parsed.source
          });
          window.localStorage.setItem("from_source", parsed.source);
        }
      }

      if (parsed.engine) {
        if (parsed.engine != "") {
          this.props.updateMarketingUser({
            prop: "signup_engine",
            value: parsed.engine
          });
          window.localStorage.setItem("signup_engine", parsed.engine);
        }
      }
      if (parsed.tier) {
        if (parsed.tier != "") {
          this.props.updateMarketingUser({
            prop: "signup_tier",
            value: parsed.tier
          });
          window.localStorage.setItem("signup_tier", parsed.tier);
        }
      }

      if (parsed.frequency) {
        if (parsed.frequency != "") {
          this.props.updateMarketingUser({
            prop: "signup_frequency",
            value: parsed.frequency
          });
          window.localStorage.setItem("signup_frequency", parsed.frequency);
        }
      }

      if (parsed.frequency) {
        if (parsed.frequency != "") {
          this.props.updateMarketingUser({
            prop: "signup_frequency",
            value: parsed.frequency
          });
          window.localStorage.setItem("signup_frequency", parsed.frequency);
        }
      }

      if (parsed.link_type) {
        this.props.updateMarketingUser({
          prop: "signup_type",
          value: parsed.link_type
        });

        if (parsed.link_type == "team_invite") {
          this.props.updateMarketingUser({
            prop: "signup_type",
            value: parsed.link_type
          });
          if (parsed.email) {
            this.props.updateMarketingUser({
              prop: "email",
              value: parsed.email
            });
            window.localStorage.setItem("email", parsed.email);
          }
          if (parsed.team_name) {
            this.props.updateMarketingUser({
              prop: "team_name",
              value: parsed.team_name
            });
          }
          if (parsed.team_company) {
            this.props.updateMarketingUser({
              prop: "team_company",
              value: parsed.team_company
            });
          }
        } else if (parsed.link_type == "team_open_invite") {
          if (parsed.team_name) {
            this.props.updateMarketingUser({
              prop: "team_name",
              value: parsed.team_name
            });
          }
          if (parsed.team_company) {
            this.props.updateMarketingUser({
              prop: "team_company",
              value: parsed.team_company
            });
          }
          if (parsed.branch_link) {
            this.props.updateMarketingUser({
              prop: "branch_link",
              value: parsed.branch_link
            });
          }
        }
      }

      if (parsed.is_partner) {
        if (parsed.is_partner == "true") {
          if (parsed.partner) {
            this.props.updateMarketingPartner({
              prop: "partner_id",
              value: parsed.partner
            });
            window.localStorage.setItem("partner_id", parsed.partner);
          }

          if (parsed.partner_logo) {
            this.props.updateMarketingPartner({
              prop: "partner_logo",
              value: parsed.partner_logo
            });
            window.localStorage.setItem("partner_logo", parsed.partner_logo);
          }

          if (parsed.partner_logo_white) {
            this.props.updateMarketingPartner({
              prop: "partner_logo_white",
              value: parsed.partner_logo_white
            });
            window.localStorage.setItem(
              "partner_logo_white",
              parsed.partner_logo_white
            );
          }
        }
      }
    }
  }

  getBranchParams() {
    if (window.branch) {
      window.branch.init(
        "key_live_mouUBnE38UD8MqbrKUpdNiomBvkD4HWb",
        (err, data) => {
          if (data) {
            const params = data.data_parsed;
            if (params) {
              if (params["~id"]) {
                if (params["~id"] != "") {
                  this.props.updateMarketingUser({
                    prop: "branch_id",
                    value: params["~id"]
                  });
                  window.localStorage.setItem("branch_id", params["~id"]);
                }
              }

              if (params["$promo"]) {
                if (params["$promo"] != "") {
                  this.props.updateMarketingUser({
                    prop: "promoText",
                    value: params["$promo"]
                  });
                  window.localStorage.setItem("promo", params["$promo"]);
                  window.localStorage.setItem("promoText", params["$promo"]);
                }
              }
              if (params["$campaign"]) {
                if (params["$campaign"] != "") {
                  this.props.updateMarketingUser({
                    prop: "from_campaign",
                    value: params["$campaign"]
                  });
                  window.localStorage.setItem(
                    "from_campaign",
                    params["$campaign"]
                  );
                }
              }
              if (params["$source"]) {
                if (params["$source"] != "") {
                  this.props.updateMarketingUser({
                    prop: "from_source",
                    value: params["$source"]
                  });
                  window.localStorage.setItem("from_source", params["$source"]);
                }
              }

              if (params["$engine"]) {
                if (params["$engine"] != "") {
                  this.props.updateMarketingUser({
                    prop: "signup_engine",
                    value: params["$engine"]
                  });
                  //window.localStorage.setItem("signup_tier", params["$engine"]);
                }
              }
              if (params["$tier"]) {
                if (params["$tier"] != "") {
                  this.props.updateMarketingUser({
                    prop: "signup_tier",
                    value: params["$tier"]
                  });
                  //window.localStorage.setItem("signup_tier", params["$tier"]);
                }
              }

              if (params["$frequency"]) {
                if (params["$frequency"] != "") {
                  this.props.updateMarketingUser({
                    prop: "signup_frequency",
                    value: params["$frequency"]
                  });
                  //window.localStorage.setItem("signup_tier", params["$tier"]);
                }
              }

              if (params["$type"]) {
                if (params["$type"] == "team_invite") {
                  this.props.updateMarketingUser({
                    prop: "signup_type",
                    value: params["$type"]
                  });

                  if (params["$email"]) {
                    this.props.updateMarketingUser({
                      prop: "email",
                      value: params["$email"]
                    });
                    window.localStorage.setItem("email", params["$email"]);
                  }
                  if (params["$team_name"]) {
                    this.props.updateMarketingUser({
                      prop: "team_name",
                      value: params["$team_name"]
                    });
                  }
                  if (params["$team_company"]) {
                    this.props.updateMarketingUser({
                      prop: "team_company",
                      value: params["$team_company"]
                    });
                  }
                }
              }

              if (params["$is_partner"]) {
                if (params["$is_partner"] == "true") {
                  if (params["$partner"]) {
                    this.props.updateMarketingPartner({
                      prop: "partner_id",
                      value: params["$partner"]
                    });
                    window.localStorage.setItem("partner", params["$partner"]);
                  }
                  if (params["$partner_logo"]) {
                    this.props.updateMarketingPartner({
                      prop: "partner_logo",
                      value: params["$partner_logo"]
                    });
                    window.localStorage.setItem(
                      "partner_logo",
                      params["$partner_logo"]
                    );
                  }
                  if (params["$partner_logo_white"]) {
                    this.props.updateMarketingPartner({
                      prop: "partner_logo_white",
                      value: params["$partner_logo_white"]
                    });
                    window.localStorage.setItem(
                      "partner_logo_white",
                      params["$partner_logo_white"]
                    );
                  }
                }
              }
            }
          }
        }
      );
    }
  }

  updateFromLocalStorage() {
    const saved_interest = window.localStorage.getItem("interest");

    if (saved_interest != null) {
      this.props.updateMarketingUser({
        prop: "interest",
        value:
          saved_interest && Array.isArray(saved_interest.split(","))
            ? saved_interest.split(",")
            : []
      });
    }
    const saved_promo = window.localStorage.getItem("promoText");
    if (saved_promo != null) {
      this.props.updateMarketingUser({ prop: "promoText", value: saved_promo });
    }

    const saved_email = window.localStorage.getItem("email");
    if (saved_email != null) {
      this.props.updateMarketingUser({ prop: "email", value: saved_email });
    }

    const saved_branch_id = window.localStorage.getItem("branch_id");
    if (saved_branch_id != null) {
      this.props.updateMarketingUser({
        prop: "branch_id",
        value: saved_branch_id
      });
    }

    const saved_from_campaign = window.localStorage.getItem("from_campaign");
    if (saved_from_campaign != null) {
      this.props.updateMarketingUser({
        prop: "from_campaign",
        value: saved_from_campaign
      });
    }
    const saved_from_source = window.localStorage.getItem("from_source");
    if (saved_from_source != null) {
      this.props.updateMarketingUser({
        prop: "from_source",
        value: saved_from_source
      });
    }
    const saved_signup_engine = window.localStorage.getItem("signup_engine");
    if (saved_signup_engine != null) {
      this.props.updateMarketingUser({
        prop: "signup_engine",
        value: saved_signup_engine
      });
    }

    const saved_signup_tier = window.localStorage.getItem("signup_tier");
    if (saved_signup_tier != null) {
      this.props.updateMarketingUser({
        prop: "signup_tier",
        value: saved_signup_tier
      });
    }

    const saved_signup_frequency = window.localStorage.getItem(
      "signup_frequency"
    );
    if (saved_signup_frequency != null) {
      this.props.updateMarketingUser({
        prop: "signup_frequency",
        value: saved_signup_frequency
      });
    }

    const saved_partner = window.localStorage.getItem("partner");
    if (saved_partner != null) {
      this.props.updateMarketingPartner({
        prop: "partner_id",
        value: saved_partner
      });
    }
    const saved_partner_logo = window.localStorage.getItem("partner_logo");
    if (saved_partner_logo != null) {
      this.props.updateMarketingPartner({
        prop: "partner_logo",
        value: saved_partner_logo
      });
    }
    const saved_partner_logo_white = window.localStorage.getItem(
      "partner_logo_white"
    );
    if (saved_partner_logo_white != null) {
      this.props.updateMarketingPartner({
        prop: "partner_logo_white",
        value: saved_partner_logo_white
      });
    }
  }

  componentDidMount() {
    if (this.props.location) {
      this.getQueryParams(this.props.location);
    }

    // init Branch
    this.getBranchParams();
    this.updateFromLocalStorage();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.user_info.promoText != prevProps.user_info.promoText &&
      this.props.user_info.promoText != null
    ) {
      this.props.getPartnerFromPromo(this.props.user_info.promoText);
    }

    if (
      this.props.partner_info.partner_id != prevProps.user_info.partner_id &&
      this.props.user_info.partner_id != null
    ) {
      window.localStorage.setItem(
        "partner",
        this.props.partner_info.partner_id
      );
      window.localStorage.setItem(
        "partner_logo",
        this.props.partner_info.partner_logo
      );
      window.localStorage.setItem(
        "partner_logo_white",
        this.props.partner_info.partner_logo_white
      );
    }
    if (prevProps.match.path !== this.props.match.path && this.props.location) {
      this.getQueryParams(this.props.location);
    }
  }

  render() {
    return <Wrapper />;
  }
}

export default withRouter(connect(null, {})(BranchAndGetParamsWrapper));
